import type { JSX } from 'react'
import type { IControlsProps } from '../Controls'

import {
  ControlBackwardInline,
  ControlForwardInline,
} from 'atoms/Button/Templates'
import { ContainerControls } from '../Controls'

/**
 * Controls always visible
 * Control is disabled if there is no pagination step
 */

export type IInlineRowControlsTemplate = Omit<IControlsProps, 'children'>

export const InlineRowControlsTemplate = ({
  controlsState = [
    {
      visible: true,
      disabled: false,
    },
    {
      visible: true,
      disabled: false,
    },
  ],
  ...rest
}: IInlineRowControlsTemplate): JSX.Element => (
  <ContainerControls controlsState={controlsState} {...rest}>
    <ControlBackwardInline />
    <ControlForwardInline />
  </ContainerControls>
)
